import { render } from "./FriendIcon.vue?vue&type=template&id=46368e4e&scoped=true"
import script from "./FriendIcon.vue?vue&type=script&lang=js"
export * from "./FriendIcon.vue?vue&type=script&lang=js"

import "./FriendIcon.vue?vue&type=style&index=0&id=46368e4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46368e4e"]])

export default __exports__